import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import { loading } from './modules/loading';
loading();


window.addEventListener("load", function(){
  gsap.registerPlugin(ScrollTrigger);

  const fv = document.querySelector(".p-home_fv");
  const fvMessage = document.querySelector(".j-message");
  const fvMessageTag = document.querySelector(".j-messagetag");
  const fvBg = document.querySelector(".j-fv_bg");
  const fvBgWrap = document.querySelector(".j-fv_bgwrap");
  const fvBgBlur = document.querySelector(".j-fv_bgblur");
  const fvTriger = document.querySelector(".j-fv_bg_trigerend");


  // ==============================
  // 背景固定
  // ==============================
  ScrollTrigger.create({
      trigger: fvTriger,
      start: "top top",   // triggerが画面下に触れた瞬間
      end: "bottom bottom", // triggerが要素の高さ分通過するまで
      pin: fvBg,        // 固定する要素
      pinSpacing: false,        // 固定中の余白を作らない（スクロールを止めるように見せる）
      // markers: true,         // デバッグ用
  });

// ==============================
// 背景：スクロールでブラー
// ==============================
  gsap.to(fvBgBlur, {
      backdropFilter: "blur(40px)",
      ease: "none",
      scrollTrigger: {
        trigger: fvMessage,
        start: "top bottom", // j-messageの上端が画面下に来たら開始
        end: "top top",      // j-messageの上端が画面上に来たら最大ブラー
        scrub: true,
        // markers: true,
      },
  });

  // ==============================
  // タイトル：中央固定 + ブラー
  // ==============================
  gsap.to(fvMessageTag, {
      filter: "blur(8px)",
      duration: 0.6,
      ease: "power2.inOut",
      scrollTrigger: {
        trigger: fvMessageTag,
        start: "center center",
        endTrigger: fvTriger, // p-home_fv が画面外に出るまで
        end: "bottom bottom",
        pin: true,
        pinSpacing: false, // ★ 下余白によるズレ防止
        toggleActions: "play none none reverse",
        // markers: true,
      },
  });

  // ==============================
  // タイトル：ボタンでフェードアウト
  // ==============================
  gsap.to(fvMessageTag, {
      opacity: 0,
      duration: 0.3,
      ease: "power2.inOut",
      scrollTrigger: {
      trigger: ".j-message_end", // .p-home_fv_message_btn に j-message_end クラスを付与
      start: "center top",    // ボタンが画面中央に来たとき
      end: "center top",
      toggleActions: "play none none reverse",
      // scrub: true,
      scrub: false,
      // markers: true,
      },
  });

  // ==============================
  // ファーストビュー：斜めカットで切り替え
  // ==============================
  gsap.to(fvBgWrap, {
      maskImage: "linear-gradient(225deg, rgb(0, 0, 0) 0%, rgb(0, 0, 0) 0%, transparent 0%, transparent 100%)",
      duration: 0.8,
      ease: "power2.inOut",
      scrollTrigger: {
          trigger: fvMessage,
          start: "+=105% top",
          end: "+=105% top",
          scrub: false,
          toggleActions: "play none none reverse",
          // markers: true,

          onEnter: () => {
            setTimeout(() => {
              // document.querySelector(".p-home_workstyle_ttl").classList.add("active");
              // document.querySelector(".p-home_workstyle_subttl").classList.add("active");
              // document.querySelector(".p-home_workstyle_btn").classList.add("active");
              fv.classList.add("u-pointer-none");
            }, 1000);
          },
          onLeaveBack: () => {
            setTimeout(() => {
              fv.classList.remove("u-pointer-none");
            }, 1000);
          }
      },
  });


  // const workstyle = document.querySelector(".p-home_workstyle");
  // const workstylePin = document.querySelector(".j-home_workstyle_pin");
  // const workstyleTriger = document.querySelector(".j-home_workstyle_trigerend");
  // const workstyleWrap = document.querySelector(".j-home_workstyle_wrap");
  // ScrollTrigger.create({
  //   trigger: workstyleTriger,
  //   start: "top top",
  //   // end: "+=150%",
  //   end: "+=150% top",
  //   pin: workstylePin,
  //   // markers: true,
  // });
  // gsap.to(workstyleWrap, {
  //   clipPath: "polygon(50% 0%, 100% 0%, 100% 0%, 50% 0%, 50% 100%, 0 100%, 0% 100%, 50% 100%)",
  //   duration: 0.5,
  //   ease: "power2.inOut",
  //   scrollTrigger: {
  //     trigger: workstyleTriger,
  //     // start: "+=100%",
  //     start: "bottom top",
  //     scrub: false,
  //     toggleActions: "play none none reverse",
  //     // markers: true,
  //     onEnter: () => {
  //       setTimeout(() => {
  //         // document.querySelector(".p-newgrads_story_head").classList.add("active");
  //         // document.querySelector(".p-newgrads_story_txtarea").classList.add("active");
  //         workstyle.classList.add("u-pointer-none");
  //       }, 500);
  //     },
  //     onLeaveBack: () => {
  //       setTimeout(() => {
  //         workstyle.classList.remove("u-pointer-none");
  //       }, 500);
  //     }
  //   }
  // });

  // const works = document.querySelector(".p-home_works");
  // const worksPin = document.querySelector(".j-home_works_pin");
  // const worksWrap = document.querySelector(".j-home_works_wrap");
  // const worksBg = document.querySelector(".j-home_works_bg");
  // const worksTriger = document.querySelector(".j-home_works_trigerend");


  // // ==============================
  // // 1）上部で固定（スクロール中に動く）
  // // ==============================
  //   ScrollTrigger.create({
  //     trigger: works,
  //     start: "top top",
  //     end: "+=200% top",//トリガーの高さを追加するcss
  //     pin: '.p-home_works_pin',
  //     anticipatePin: 1,
  //     // markers: true,
  //   });

  //   // ==============================
  //   // 2）下端で固定（次のセクションが迫り上がる）
  //   // ==============================
  //   ScrollTrigger.create({
  //     trigger: worksTriger,
  //     start: "bottom bottom",   // aboutの上端が画面下に来た瞬間
  //     end: "bottom top",
  //     pin: '.p-home_works_pin',
  //     anticipatePin: 1,
  //     // markers: true,
  //   });



    // ==============================
    // 1）タイトルブロック固定
    // ==============================
    // ScrollTrigger.create({
    //   trigger: ".p-home_about",
    //   start: "top top",
    //   // end: "+=150%",
    //   end: "+=100% top",
    //   pin: ".p-home_about",
    //   // pinSpacing: false,
    //   markers: true,
    // });
    ScrollTrigger.create({
      trigger: ".p-home_about_card-1",
      start: "top top",
      // end: "+=150%",
      end: "+=350% top",
      pin: ".p-home_about_card-1",
      pinSpacing: false,
      // markers: true,
    });
    ScrollTrigger.create({
      trigger: ".p-home_about_card-2",
      start: "top top",
      // end: "+=150%",
      end: "+=150% top",
      pin: ".p-home_about_card-2",
      pinSpacing: false,
      // markers: true,
    });
    ScrollTrigger.create({
      trigger: ".p-home_about_card-3",
      start: "top top",
      // end: "+=150%",
      end: "+=150% top",
      pin: ".p-home_about_card-3",
      pinSpacing: false,
      // markers: true,
    });

    // ScrollTrigger.create({
    //     trigger: ".p-home_about",
    //     start: "top top",
    //     end: "bottom bottom",
    //     pin: ".p-home_about_ttlwrap",
    //     pinSpacing: false,
    //     // anticipatePin: 1,
    //     // markers: true,
    //     // onEnter: () => {
    //     // ttl?.classList.add("active");
    //     // subttl?.classList.add("active");
    //     // btn?.classList.add("active");
    //     // },
    //     onEnter: (self) => {
    //         const active = self.isActive;
    //         document.querySelector(".p-home_about_ttl")?.classList.add("active", active);
    //         document.querySelector(".p-home_about_subttl")?.classList.add("active", active);
    //     },
    // });

    // ==============================
    // 2）セクション上部到達時：ttlwrapにactive付与
    // ==============================
    // ScrollTrigger.create({
    // trigger: ".p-home_about",
    // start: "top top",
    // onEnter: () => {
    //     document.querySelector(".p-home_about_ttlwrap")?.classList.add("active");
    // },
    // // onLeaveBack: () => {
    // //     document.querySelector(".p-home_about_ttlwrap")?.classList.remove("active");
    // // },
    // // markers: true,
    // });

    // ==============================
    // 3）各カード到達時：内部要素にactive付与
    // ==============================
    document.querySelectorAll(".p-home_about_card_cmn").forEach((card) => {
    const ttl = card.querySelector(".p-home_about_card_cmn_ttl");
    const subttl = card.querySelector(".p-home_about_card_cmn_subttl");
    const btn = card.querySelector(".p-home_about_card_cmn_btn");

    ScrollTrigger.create({
        trigger: card,
        start: "top top", // 少し手前で発火するなら「top 80%」なども可
        onEnter: () => {
        ttl?.classList.add("active");
        subttl?.classList.add("active");
        btn?.classList.add("active");
        },
    });
    });
        // ScrollTrigger.refresh();

});

const isMobile = window.matchMedia("(max-width: 768px)").matches;

if(!isMobile) {
  let resizeTimer;

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      location.reload();
    }, 500); // ← 0.5秒後にリロード
  });
}

